import React, { useState } from 'react';
import styled from 'styled-components';
import { Color } from '~common/model/basics';
import { Box } from '~common/components/box.component';
import { Button } from '~common/components/button/button.component';
import {
  DropdownSelectMenu,
  DropdownSelectMenuOption,
} from '~web/view/components/ui/form/dropdown-select-menu.component';

const data = [
  {
    name: 'one',
    value: '1',
  },
  {
    name: 'two',
    value: '2',
  },
  {
    name: 'three',
    value: '3',
  },
];

export const DropdownTest: React.FunctionComponent = () => {
  const [selection, setSelection] = useState('No option selected');
  const handleSelection = (value: string): void => {
    const found = data.find((option) => value === option.value);
    found && setSelection(found.name);
  };

  const options = data.map(
    (obj): DropdownSelectMenuOption => ({
      value: obj.value,
      name: obj.name,
    }),
  );

  return (
    <Container>
      <DropdownSelectMenu
        currentValue={selection}
        options={options}
        handleItemSelected={handleSelection}
      >
        <Button color={Color.White}>{selection}</Button>
      </DropdownSelectMenu>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: ${(props): string => props.theme.colors.black};
`;



// WEBPACK FOOTER //
// ./view/components/__tests__/components/dropdown.test.component.tsx